const SUPPORTED_ORDER_TYPES = new Set(['Lien Search', 'Estoppel']);

const round2 = n => Math.round((Number.isFinite(n) ? n : 0) * 100) / 100;

const toNumber = v => {
  if (v === '' || v === null || v === undefined) return 0;
  const n = parseFloat(String(v).replace(/[$,\s]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

export function sumInvoiceLineAmounts(feeSourceInvoices) {
  const rows = feeSourceInvoices?.invoices;
  if (!Array.isArray(rows) || rows.length === 0) return 0;
  return rows.reduce((sum, row) => sum + toNumber(row?.invoiceAmount), 0);
}

export function computeCollectedFees(order, feeSourceInvoices) {
  if (!order || !SUPPORTED_ORDER_TYPES.has(order.orderType)) return null;
  if (feeSourceInvoices == null) return null;
  const invoiceTotal = sumInvoiceLineAmounts(feeSourceInvoices);
  return round2(invoiceTotal - toNumber(order.hardCost));
}

export function getInvoiceAmountForOrder(order) {
  if (!order || order.feeSourceInvoices == null) return null;
  return sumInvoiceLineAmounts(order.feeSourceInvoices);
}

/** Comma-separated non-empty invoice numbers from feeSourceInvoices, or null if none. */
export function getInvoiceNumbersForOrder(order) {
  const rows = order?.feeSourceInvoices?.invoices;
  if (!Array.isArray(rows) || rows.length === 0) return null;
  const numbers = rows.map(row => String(row?.invoiceNumber || '').trim()).filter(Boolean);
  return numbers.length > 0 ? numbers.join(', ') : null;
}
